import Vue from 'vue'
// 引入vuex
import Vuex from 'vuex'
// 引入vuex持久话存储插件
import createPersistedState from 'vuex-persistedstate'
// 引入事项
import itemService from './modules/item-service'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 服务人员类型
    serviceType: 'personal',
    config: {},
    // 用户信息
    userInfo: {
      isLogin: false
    },
    // 预约事项id
    appId: '',
    // 私钥
    privateKey: '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7',
    // 登录状态
    isLogin: false,
    // 预约记录id
    itemId: '',
    // 区划信息
    areaInfo: '320000000000',
    // 帮代办类型
    // 音视频组件参数JSON格式
    meetingParams: {}
  },
  mutations: {
    // 修改服务人员类型
    checkServiceType(state, type) {
      Vue.set(state, 'serviceType', type)
    },
    // 存入用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    // 存入预约事项id
    setAppId(state, appId) {
      state.appId = appId
    },
    // 存入事项id
    setItemId(state, id) {
      state.itemId = id
    },
    // 设置登录状态
    setLoginState(state, loginState) {
      state.isLogin = loginState
    },
    // 存入区划
    setAreaInfo(state, areaInfo) {
      state.areaInfo = areaInfo
    },
    // 存入加密的用户信息
    setConfig(state, config) {
      state.config = config
    },
    // 存入音视频组件参数
    setMeetingParams(state, meetingParams) {
      state.meetingParams = meetingParams
    }
  },
  // 引入模块
  modules: {
    itemService
  },
  // 使用vuex持久化存储插件
  plugins: [createPersistedState()]
})

// 导出仓库
export default store
